// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"1dc5883a","727":"6fa0d12a","734":"81f8f4d1","787":"727477e6","932":"08f50a81"}[chunkId] + ".chunk.js";
};